const {
  PostFormApi,
  validate_input_field,
  submit_response,
} = require("../utils/func");

const formObject = {};

export const process_register_for_program = (e) => {
  e.preventDefault();
  console.log("register");
  let selected_programs = document.querySelectorAll(".cart-items-select");
  let program_ids = [];
  if (typeof selected_programs !== "undefined" && selected_programs !== null) {
    selected_programs.forEach((program) => {
      if (program.checked === true) {
        program_ids.push(program.value);
      }
    });
  }

  let formField = document.querySelectorAll(".program-validate-input");
  let dataValues = document.querySelectorAll(".program-form-input");
  let fullName,
    validate = [],
    user = {},
    accept = 0;

  formField.forEach((el) => {
    validate.push(validate_input_field(el));
  });

  if (program_ids.length == 0) {
    let show_program_error = document.getElementById("invalid-enroll");
    show_program_error.style.display = "block";
    window.scrollTo({
      top: document.querySelector("#invalid-enroll").offsetTop,
      behavior: "smooth",
    });
    validate.push(1);
  }

  //specialty input
  let getSpecialty = document.getElementById("specialty");
  let getSpecialtyInput = document.getElementById("specialtyInput");
  let specialtyValue = getSpecialty.options[getSpecialty.selectedIndex].value;
  let show_specialty_error = document.getElementById("invalid-specialty");

  if (specialtyValue == "select") {
    show_specialty_error.style.display = "block";
    window.scrollTo({
      top: document.querySelector("#invalid-specialty").offsetTop,
      behavior: "smooth",
    });
    validate.push(1);
  } else {
    show_specialty_error.style.display = "none";
  }

  if (validate.length == 0 || validate.indexOf(1) == -1) {
    console.log("programs ids: ", program_ids);
    //   console.log("PROCESSING...");
    grecaptcha
      .execute("6LcIJ6cUAAAAABzDuwpRp8UWOkteEUrySZ2cUg1j", {
        action: "save_the_date_register_for_program",
      })
      .then((token) => {
        let formData = {};
        dataValues.forEach((input) => {
          let value = input.value;
          let name = input.getAttribute("name");
          formData[name] = value;
        });
        //get autoEnroll value
        let autoEnroll = 0;
        let auto_enroll = document.querySelector("input[name='auto-enroll']");
        if (auto_enroll.checked) {
          autoEnroll = 1;
        }
        formData.autoEnroll = autoEnroll;
        formData.programs = program_ids.toString();
        console.log(formData);
        let fd = { ...formData };
        for (let i in fd) {
          if (fd.hasOwnProperty(i)) {
            fd[i] = btoa(fd[i]);
          }
        }
        let user = {
          formData: fd,
          token: token,
          submit: true,
        };
        PostFormApi(
          "api/register_for_program/register_for_program.php",
          user
        ).then((res) => {
          window.location.href = "thank-you.php";
        });
      });
  }
};

export const setSpecialtyBox = (e) => {
  let specialtybox = document.getElementById("specialtyInput");
  if (e.target.value == "Other") {
    specialtybox.className += " validate-input form-input";
    specialtybox.style.display = "block";
  } else {
    specialtybox.classList.remove("validate-input");
    specialtybox.style.display = "none";
  }
};
